import { Controller } from 'stimulus';

class ApplicationProvider extends Controller {
  connect() {
    window.primaryApplication = this.application;
  }
}

export default ApplicationProvider;
